import { ReactElement } from "react";

import { Pill } from "ui/Pill/Pill";

type IconTextPillProps = {
  icon: ReactElement;
  text: string;
  testId?: string;
  color?: string;
};

export function IconTextPill({ icon, text, color, testId }: IconTextPillProps) {
  return (
    <Pill color={color} data-testid={testId}>
      <Pill.Icon icon={icon} />
      <Pill.Text>{text}</Pill.Text>
    </Pill>
  );
}
